import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { referralCodeInquire } from 'src/app/shared/services/referal-code-inquire.service';

@Component({
  selector: 'app-referrals-code-navigate',
  templateUrl: './referrals-code-navigate.component.html',
  styleUrls: ['./referrals-code-navigate.component.scss'],
})
export class ReferralsCodeNavigateComponent implements OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private checkRefCode: referralCodeInquire,
    private router: Router
  ) {}

  subscription: Subscription;
  result: { status: string };

  ngOnInit(): void {
    this.subscription = this.route.paramMap.subscribe(async (params) => {
      if (params) {
        this.checkRefCode.setParams({ code: params.get('code') });
        this.result = await this.checkRefCode.make();
        if (this.result.status === 'found') {
          sessionStorage.setItem('referralCode', params.get('code'));
          this.router.navigate(['signup']);
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
